import { POLITICA_PRIVACIDADE_VERSAO } from '@econdominio/core/privacidade';

/**
 * Conteúdo da Política de Privacidade (#74 / RNF-L04). Componente puro reutilizado
 * pela página pública e pela tela autenticada do titular. A versão vigente vem do
 * core (registrada no consentimento).
 */
export function PoliticaConteudo() {
  return (
    <div style={{ display: 'grid', gap: 'var(--space-3)', lineHeight: 1.6 }}>
      <p style={{ opacity: 0.7, margin: 0 }}>Versão {POLITICA_PRIVACIDADE_VERSAO}</p>

      <section>
        <h3>1. Quem somos</h3>
        <p>
          Esta plataforma administra a gestão do seu condomínio (comunicação, financeiro,
          arrecadação e documentos). O tratamento de dados pessoais segue a Lei Geral de Proteção de
          Dados (LGPD, Lei 13.709/2018).
        </p>
      </section>

      <section>
        <h3>2. Quais dados tratamos</h3>
        <ul>
          <li>Identificação e contato (nome, e-mail, telefone, CPF quando aplicável).</li>
          <li>
            Vínculo com a unidade (morador/proprietário) e histórico financeiro do condomínio.
          </li>
          <li>Dados de acesso e segurança (registro de login, para prevenção de fraude).</li>
        </ul>
      </section>

      <section>
        <h3>3. Finalidade e base legal</h3>
        <p>
          Tratamos os dados para executar a administração condominial (execução de contrato e
          obrigação legal), comunicar avisos e viabilizar a arrecadação. Dados de segurança têm base
          no legítimo interesse de proteção da conta.
        </p>
      </section>

      <section>
        <h3>4. Retenção</h3>
        <p>
          Mantemos dados pessoais enquanto houver vínculo com o condomínio e pelos prazos legais
          aplicáveis (fiscais/contábeis). Registros de segurança e logs de acesso são expurgados
          periodicamente conforme nossa política de retenção.
        </p>
      </section>

      <section>
        <h3>5. Seus direitos</h3>
        <p>
          Você pode solicitar <strong>acesso</strong>, <strong>correção</strong> ou{' '}
          <strong>eliminação</strong> dos seus dados. Titulares autenticados podem registrar o
          pedido diretamente pelo aplicativo, na área "Privacidade e meus dados".
        </p>
      </section>

      <section>
        <h3>6. Contato</h3>
        <p>
          Dúvidas sobre privacidade podem ser encaminhadas à administração do condomínio, que atua
          como controladora dos dados.
        </p>
      </section>
    </div>
  );
}
